import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { EntityName, MessageType } from '@shared/enums/entity-name.enum';
import { WINDOW } from '@shared/helpers/window.token';
import { NewsMessageInterface } from '@shared/interfaces/news-message.interface';
import { ScrollingHandlerService } from '@shared/services/scrolling-handler.service';
import { isBackForwardNavigation } from '@shared/utils/common.utils';
import { BaseHttpService } from '@src/app/core/http/base-http.service';
import { TemplateName } from '@src/app/shared/constants/visibility-config.const';
import { GlobalEventBus } from '@src/app/shared/enums/event-bus.enum';
import { EventBusService } from 'ngx-eventbus';
import { Event as EventBus } from 'ngx-eventbus/lib/service/event';

@Component({
  selector: 'app-news-and-message-list',
  templateUrl: './news-and-message-list.component.html',
  styles: [],
})
export class NewsAndMessageListComponent implements OnInit, OnDestroy {
  @Input() items: NewsMessageInterface[];

  @Input() uiTemplateConfig: TemplateName = TemplateName.Default;

  @Input() currentUserId: number;

  @Input() backgroundColor: string;

  @Input() isSearchResultPage = false;

  @Output() likesModalOpened = new EventEmitter<NewsMessageInterface>();

  @Output() commentModalClosed = new EventEmitter<NewsMessageInterface>();

  MessageType = MessageType;

  EntityName = EntityName;

  listItemAdded: EventBus;

  constructor(
    @Inject(WINDOW) private window: Window,
    private scrollingHandlerService: ScrollingHandlerService,
    private readonly eventBus: EventBusService,
    private readonly listService: BaseHttpService<any>
  ) {}

  ngOnInit(): void {
    this.listenToNewMessageAdded();
  }

  restorePosition(id: number): void {
    if (this.shouldRestorePosition(id)) {
      this.scrollingHandlerService.restorePosition(EntityName.News, id);
    } else {
      this.scrollingHandlerService.isRestorationComplete = true;
    }
  }

  openLikesModal(item: NewsMessageInterface): void {
    this.likesModalOpened.emit(item);
  }

  syncCommentStateCount(news: NewsMessageInterface): void {
    this.commentModalClosed.emit(news);
  }

  onVisible(item: number, isVisible: boolean): void {
    this.scrollingHandlerService.saveItem(
      EntityName.News,
      isVisible,
      item.toString()
    );
  }

  listenToNewMessageAdded(): void {
    this.listItemAdded = this.eventBus.addEventListener({
      name: GlobalEventBus.ListItemUpdate,
      callback: (item) => {
        if (!this.isSearchResultPage) return;
        this.updateItemInList(item);
      },
    });
  }

  updateItemInList(itemToUpdate: any, key: string = 'id'): void {
    if (!itemToUpdate || !this.items) return;

    const index = this.items.findIndex(
      (item) => item[key] === itemToUpdate[key]
    );
    if (index === -1) return;

    this.items[index] = this.listService.tranformData(itemToUpdate);
  }

  private shouldRestorePosition(id: number): boolean {
    return this.items[0].id !== id && isBackForwardNavigation(this.window);
  }

  ngOnDestroy(): void {
    if (this.eventBus) {
      this.eventBus.removeEventListener(this.listItemAdded);
    }
  }
}
